import * as types from "@/store/subscriptionplan/types";

export default {
  [types.SET_SUBSCRIPTIONOBJECT](state, payload) {
    state.currentSubscriptionObject = payload;
  },
  [types.SET_SUBSCRIPTIONPLANLIST](state, payload) {
    state.subscriptionplanList = payload;
  }
};
